import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { ApiService } from '../../../../@core/service/api.service';
import { DocConfig, CompilationTypeData, UnitData, DocumentStatusData, InvoicePaymentData }
  from '../../../../@models/erp/compilationData';
import { DatePipe } from '@angular/common';
import { BusinessModel, FileModel } from '../../../../@models';
import { LineItemModel } from '../../../../@models/erp/lineItem';
import { getDocumentNumber, isEmpty, mongoId } from '../../../../@core/common/global';
import { TreeService } from '../../../../@core/service/tree.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import * as saveAs from 'file-saver';
import { LineItemContainerComponent } from '../line-item-container/line-item-container.component';
import * as moment from 'moment';
import { DocumentComponent } from '../document.component';

export class DownloadConfig {
  html: string = null;
  css: string = null;
  cssFiles: string[] = [];
  table: string = null;
  footer: string = null;
  compilation: string = null;
  copy: boolean = false;
  merge: boolean = false;
  zip: boolean = false;
  attachmentsOnly: boolean = false;
  orientation: string = 'Portrait';
  pdfType: { type: string, name: string, files: FileModel[] };
  fileData: any;
  pageSize: any = 'A4';
  noheader: boolean = false;
  nofooter: boolean = false;
  nomargin: boolean = false;
  pageOffset: number = null;
}

@Component({
  selector: 'ngx-document-printer',
  templateUrl: './document-printer.component.html',
  styleUrls: ['./document-printer.component.css'],
})
export class DocumentPrinterComponent implements OnInit, OnChanges {

  @Input() compilation: CompilationModel;
  // @Input() businesses: BusinessModel[];
  @Input() documentComponent: DocumentComponent;
  @Input() userOptions: { id: string, name: string};
  // @Input() issuedBy: string;
  // @Input() meansOfTransportation: string;
  // @Input() compilationData: any;
  @Input() deliveryConditions: string;
  @Input() taxHint: string;
  @Input() relatedDocuments: string[] = [];
  @Input() visibleSections: any;
  @Input() latestVersionItems: CompilationModel[];
  @Input() buttons = true;
  @Input() lineItemsComponent: LineItemContainerComponent;
  @Input() boxBlockValues = [];
  @Output() done = new EventEmitter<string>();

  reportDateFields = DocConfig.getArray()
    .filter(f => f.value['type'] === 'reportDate');

  orderLineItems: LineItemModel[] = [];

  netTotal = 0;
  partialNetTotal = 0;
  discountedNetTotal = 0;
  subTotal = 0;
  partialSubTotal = 0;
  discountedSubTotal = 0;
  vatTotal = 0;
  partialVatTotal = 0
  discountedVatTotal = 0
  sumTotal = 0;
  partialSumTotal
  discountedSumTotal
  vatItems = [];

  deductibleTotal = 0;
  ppInvoicesTotal = 0;

  ppNetTotal = 0;
  ppPartialNetTotal = 0;
  ppDiscountedNetTotal = 0;

  showGrossWeight = false;

  boxBlockLines: any;

  obicCodes = [];

  unitOptions = UnitData;
  docConfig = DocConfig;
  typeData = CompilationTypeData;

  constructor(
    private api: ApiService,
    public data: SharedDataService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    public tree: TreeService,
  ) { }

  ngOnInit() {
    this.data.loadBusinesses();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.compilation?.currentValue) {
      this.data.setDocConfigMaps(this.compilation.type);
    }

    this.deductibleTotal = this.compilation.deductibleItems &&
                           this.compilation.deductibleItems.reduce((sum, item) => sum + (1 * item.value), 0);

    this.ppInvoicesTotal = 0;
    this.compilation.paymentPlan?.items?.forEach(item => {
      item?.invoices?.forEach(inv => {
        this.ppInvoicesTotal += (inv.net || 0)
      })
    });

    this.vatItems = [];
    if (this.compilation.lineItems) {
      let idx = 0;
      for (const li of this.compilation.lineItems) {

        // fix quantity rounding issue (10 decimals)
        li.quantity = Number(li.quantity.toFixed(10))

        const vat = +li.VATPercent;
        if (vat >= 0) {
          if (!this.vatItems.find(s => s.vat === vat)) {
            this.vatItems.push({ vat: vat, sum: 0, partialVat: 0, discountedVat: 0});
          }
          this.vatItems.find(s => s.vat === vat).sum += li.quantity * li.piecePrice;
          this.vatItems.find(s => s.vat === vat).partialVat += li.quantity * li.piecePrice * li.invoicePercent / 100;
          this.vatItems.find(s => s.vat === vat).discountedVat += li.quantity * li.piecePrice * (100-li.discount) / 100;
        }
        this.boxBlockValues[idx++] = {}
      }
    }
    if (this.vatItems.length > 0) {
      this.vatItems[0].sum += this.deductibleTotal + this.ppInvoicesTotal;;
      this.vatItems[0].partialVat += this.deductibleTotal + this.ppInvoicesTotal;;
      this.vatItems[0].discountedVat += this.deductibleTotal + this.ppInvoicesTotal;;
    }
    // this.subTotal = this.compilation.lineItems &&
    //       this.compilation.lineItems.reduce((sum, item) => sum + (item.quantity * item.piecePrice), 0)
    // this.netTotal = this.subTotal +  this.discountTotal;
    // this.vatTotal = this.vatItems && this.vatItems.reduce((sum, item) => sum + (item.sum * item.vat / 100), 0);
    // this.sumTotal = this.netTotal + this.vatTotal;

    this.subTotal = this.compilation.lineItems && this.compilation.lineItems
      .reduce((sum, item) => sum + (item.quantity * item.piecePrice), 0)
    this.partialSubTotal = this.compilation.lineItems && this.compilation.lineItems
      .reduce((sum, item) => sum + (item.quantity * item.piecePrice * (item.invoicePercent/100)), 0)
    this.discountedSubTotal = this.compilation.lineItems && this.compilation.lineItems
      .reduce((sum, item) => sum + (item.quantity * item.piecePrice * ((100-item.discount)/100)), 0)
    this.netTotal = this.subTotal +  this.deductibleTotal;
    this.partialNetTotal = this.partialSubTotal + this.deductibleTotal;
    this.discountedNetTotal = this.discountedSubTotal + this.deductibleTotal;
    this.ppNetTotal = this.netTotal + this.ppInvoicesTotal;
    this.ppPartialNetTotal = this.partialNetTotal + this.ppInvoicesTotal;
    this.ppDiscountedNetTotal = this.discountedNetTotal + this.ppInvoicesTotal;
    this.vatTotal = this.vatItems && this.vatItems.reduce((sum, item) => sum + (item.sum * item.vat / 100), 0);
    this.partialVatTotal = this.vatItems && this.vatItems
      .reduce((sum, item) => sum + (item.partialVat * (item.vat / 100)), 0);
    this.discountedVatTotal = this.vatItems && this.vatItems
      .reduce((sum, item) => sum + (item.discountedVat * (item.vat / 100)), 0);
    this.sumTotal = this.ppNetTotal + this.vatTotal;
    this.partialSumTotal = this.ppPartialNetTotal + this.partialVatTotal;
    this.discountedSumTotal = this.ppDiscountedNetTotal + this.discountedVatTotal;

    // console.log('onChange', CompilationTypeData.get('OC').id === this.compilation.type, this.compilation.parent)
    // if (CompilationTypeData.get('OC').id === this.compilation.type && this.compilation.parent) {
    //   this.orderLineItems = (this.tree.findDoc(this.compilation.parent) || {} as any).lineItems;
    //   console.log('oli', this.orderLineItems);
    // }
    this.orderLineItems = this.tree.linkedOR?.lineItems;

    // console.log('linked OR', this.tree.linkedOR?.code, this.tree.linkedOR);

    this.showGrossWeight = this.data.visibleMap.grossWeight && this.compilation.lineItems?.reduce((a, c) => a + c.weight, 0) > 0;

    // if (this.lineItemsComponent?.obicCodes) {
    //   this.obicCodes = this.lineItemsComponent.obicCodes
    // }
    this.compilation.lineItems.forEach((li, idx) => {
      this.obicCodes[idx] = this.getObicCodes(li);
    })

    // if (changes.lineItemsComponent?.currentValue) {
    //   this.boxBlockLines = this.lineItemsComponent.boxBlockLines;
    // }


  }

  getObicCodes(item: LineItemModel) {
    const spoLineItems = item.pfspo.map(m => this.tree.linkedPfspos?.find(f => f.code === m.code)?.lineItems[m.pos-1]);
    // console.log('spoLineItems', item.pfspo, spoLineItems, this.tree.linkedPfspos);
    const obics = Array.from(new Set( spoLineItems?.filter(f => f?.tbCode).map((m, idx) => `${item.pfspo[idx]?.quantity} ${m?.tbCode}` )));
    // console.log('obics: ', obics, spoLineItems);
    const text = obics ? obics.filter(notNull => notNull)?.join('\n') : item.tbCode || '';
    // console.log('=========---> obics text', text, obics);
    return text;
  }

  // showField(section: string) {
  //   switch (section) {
  //     case 'paymentPlan': const pp = this.compilation.paymentPlan; return pp && pp.items && pp.items.length;
  //     case 'packingConditions': const pc = this.compilation.packingConditions; return pc != null;
  //     case 'deliveryConditions': const dc = this.compilation.deliveryConditions;
  //       return dc && (dc.country || dc.place || dc.incoterms)
  //     case 'termsOfPayment': const tp = this.compilation.paymentPlan;
  //       return tp && (tp.recipientUID || tp.termsOfPayment || tp.text);
  //     case 'documents': return this.compilation.documents && this.compilation.documents.length;
  //     case 'internalDocuments': return this.compilation.documentsInternal && this.compilation.documentsInternal.length;
  //     case 'relatedDocuments': return this.relatedDocuments && this.relatedDocuments.length > 1;
  //     case 'finishedProductPdf': return this.compilation.lineItems.find(f => f.finishedProductPdf > 0);
  //     case 'technicalDatasheetPdf':
  //       return this.compilation.lineItems.find(f =>
  //         f.technicalDatasheets && f.technicalDatasheets.find(tds => tds > 0)
  //       );
  //     case 'obicSummary': return true;
  //     case 'associatedPfspoList': return true;
  //     case 'barcodes': return true;
  //     case 'accountManager': return false;
  //     case 'invoiceRemark': return true;
  //     case 'bankAddress': return false;
  //   }
  //   return this.compilation[section] && this.compilation.visibleFields
  //     && this.compilation.visibleFields.includes(section);
  // }

  isPartialPayment() {
    return +this.compilation.invoicePayment === 1 || +this.compilation.invoicePayment === 2
  }

  isDiscount(item: LineItemModel = null) {
    // if (item) return item.discount > 0;
    return !this.isPartialPayment()
      && this.compilation.lineItems.find(li => li.discount > 0);
  }

  // isEmpty(text: string) {
  //   // console.log('importer addr', this.compilation.importerAddress, this.compilation.importerInfo, this.compilation.importerRecipient);
  //   return text === null || text === undefined || /^[\s\n\r\t]*$/.test(text);
  // }
  protected isEmpty = isEmpty; // forward from global.ts to template

  getSectionValue(item) {
    return this.compilation[item.key];
  }

  getSectionOptionsValue(item) {
    const opt = item.value.options && item.value.options.find(f => f.id === this.compilation[item.key])
    return (opt && opt.name) || this[item.value['optionsField']].find(f => f.id === this.compilation[item.key]).name;
  }

  text2html(text: string) {
    return text.replace('\n', '<br>');
  }

  onClosePreview() {
    this.done.emit('done');
  }

  async onDownloadPdf(merge: boolean = false, copy: boolean = false, zip: boolean = false, attachmentsOnly: boolean = false) {

    // const changelogLite = this.compilation.visibleFields
    //   && this.compilation.visibleFields.includes('changelogLite')
    //   && document.getElementById('changelogLite').innerHTML;

    // console.log('changelog lite', changelogLite, document.getElementById('changelogLite'));

    const config = new DownloadConfig()
    config.html = this.elRef.nativeElement.innerHTML;
    config.css = 'document-printer.css';
    // config.footer =`
    //   ${changelogLite ? '<div id="lastPageExtra" style="position:absolute;bottom:0">' + changelogLite + '<br></div>' : ''}
    // config.footer =`
    //   <table style="width: 100%; border-top: 1px solid black;">
    //     <tr>
    //       <td rowspan="2">
    //         <div style="text-align:center;white-space:pre;font-size:smaller;">
    //           ${this.compilation.documentFooter && this.compilation.documentFooter.address}
    //         </div>
    //       </td>
    //       <td rowspan="2">
    //         <div style="text-align:center;white-space:pre;font-size:smaller;">
    //           ${this.compilation.documentFooter && this.compilation.documentFooter.registry}
    //         </div>
    //       </td>
    //       <td rowspan="2">
    //         <div style="text-align:center;white-space:pre;font-size:smaller;">
    //           ${this.compilation.documentFooter && this.compilation.documentFooter.bank}
    //         </div>
    //       </td>
    //     </tr>
    //     <tr>
    //       <td colspan="3" rowspan="3">
    //       </td>
    //       <td>
    //         <span class="page"></span>&nbsp;/&nbsp;<span class="topage"></span>
    //       </td>
    //     </tr>
    //   </table>
    // `,

    // ${this.compilation.documentFooter && this.compilation.documentFooter.address}
    // ${this.compilation.documentFooter && this.compilation.documentFooter.registry}
    // ${this.compilation.documentFooter && this.compilation.documentFooter.bank}

    config.footer =`
      <div style="position:relative;top:-0.5rem;width:96%;padding-left:2%;padding-right:2%;padding-bottom:1rem;border-top: 1px solid black;font-size:10pt;">
        <ul style="position:relative;top:-1.5rem;display:table;width:100%;table-layout:fixed;list-style:none;padding:0;margin:0;">
          <li style="display:table-cell;text-align:left;">
            <div style="width:13rem;white-space:pre-wrap">
              ${this.compilation.documentFooter && this.compilation.documentFooter.address}
            </div>
          </li>
          <li style="display:table-cell;white-space:pre;text-align:center">
              ${this.compilation.documentFooter && this.compilation.documentFooter.registry}
          </li>
          <li style="display:table-cell;white-space:pre;text-align:right">
              ${this.compilation.documentFooter && this.compilation.documentFooter.bank}
          </li>
        </ul>
      </div>
      <div style="position:absolute;bottom:0;right:0;font-size:11pt;"><span class="page"></span>&nbsp;/&nbsp;<span class="topage"></span></div>
    `,
    config.compilation = this.compilation._id,
    config.copy = copy,
    config.merge = merge,
    config.zip = zip,
    config.attachmentsOnly = attachmentsOnly;

    if (!zip) {
      config.pdfType = { type: 'doc', name: 'Documents', files: null };
      await this.doDownloadPdf(config);
      this.done.emit('done');
      return;
    }

    const pdfTypes = (this.compilation.documents as FileModel[][] || [])
      .map((el, idx) =>
        el !== null
        && el.find(f => f.checked)
        && ({ type: ''+idx, name: idx === 0 ? 'PRDocs' : CompilationTypeData.get(idx).code + 'Docs', files: el })
      )
      .filter(f => f);

    pdfTypes.push({
      type: 'doc', name: 'Document', files: null,
    }, {
      type: 'zipTDS', name: 'TDS', files: null,
    }, {
      type: 'zipFP', name: 'FP', files: null,
    }, {
      type: 'zipChangelog', name: 'CL', files: null,
    });


    for (const pdfType of pdfTypes) {
      const conf = Object.assign({}, config);
      conf.pdfType = pdfType;
      switch (pdfType.type) {
        case 'doc':
          await this.doDownloadPdf(conf);
          break;
        default:
          conf.attachmentsOnly = true;
          conf.html = '';
          conf.css = '';
          conf.footer = '';
          conf.table = '';
          await this.doDownloadPdf(conf);
      }
    }

    this.done.emit('done');
  }

  async doDownloadPdf(config: DownloadConfig) {

    // console.log('downloadPdf', config);
    return new Promise(resolve => {
      this.api.getDocumentFile('/api/v1/compilation/pdf', config).subscribe(async res => {
        const date =
          this.datePipe.transform(this.compilation.issueDate ? this.compilation.issueDate : new Date(), 'yyMMdd');
        const editCount = '‑' + (this.compilation.editCount ? [0, 0].splice(('' + this.compilation.editCount).length).join('') + this.compilation.editCount : '01');
        const docnum = getDocumentNumber(this.compilation)?.replace(/ ‑ /, '-') + (this.compilation.nameOverride ? editCount : '');
        let revised = this.compilation.documentStatus === DocumentStatusData.get('revised').id ?'_REVISED' : '';
        const cancelled = this.compilation.documentStatus === DocumentStatusData.get('cancelled').id ?'_cancelled' : '';
        const poPos = this.compilation.customerPoPosition ? `${this.compilation.customerPoPosition} ` : '';
        const customerDoc = this.compilation.customerDocumentNumber ? `${this.compilation.customerDocumentNumber} ` : '';
        const customerCode = this.compilation.lineItems?.[0]?.attributeCode ? `${this.compilation.lineItems?.[0]?.attributeCode?.replace(/\n/g, '')} ` : '';
        // const quantity = this.compilation.lineItems.reduce((a, c) => a + c.quantity, 0) ?? '';
        const copyTxt = config.copy ? '_copy' : '';
        const ext = config.zip ? ` - ${config.pdfType.name}.zip` : '.pdf'
        const issueFiscalYear = moment(this.compilation.issueDate).isBefore(moment(`${moment(this.compilation.issueDate).year()}-10-01`))
          ? moment(this.compilation.issueDate).year()-1
          : moment(this.compilation.issueDate).year();
        const fiscalAnnotation = issueFiscalYear !== this.compilation.fiscalYear
          ? `_FY${this.compilation.fiscalYear}-${(this.compilation.fiscalYear + 1).toString().slice(-2)}` 
          : ''
        if (['IN'].includes(CompilationTypeData.get(this.compilation.type).code) && fiscalAnnotation) {
          revised = fiscalAnnotation + revised;
        }

        console.log(`save test: date: ${date}, docnum: ${docnum}, cancelled: ${cancelled}, poPos: ${poPos}, customerDoc: ${customerDoc}, customerCode: ${customerCode}, copyTxt: ${copyTxt}, ext: ${ext}, issueFiscalYear: ${issueFiscalYear}, fiscalAnnotation: ${fiscalAnnotation}`);
        console.log('save inFiscal', issueFiscalYear, this.compilation.fiscalYear, fiscalAnnotation);
        let filename = '';
        if (this.compilation.recipient) {
          // this.api.loadBusiness(this.compilation.recipient.toString()).subscribe(business => {
            const isDN = this.compilation.type === CompilationTypeData.get('DN').id;
            const business = this.data.businesses.find(f => mongoId(f) === mongoId(isDN ? this.compilation.deliveryRecipient : this.compilation.recipient));
            const name = business && business.name; // && business.name.replace(/\s/g, '_');
            // eslint-disable-next-line max-len
            if (['OR', 'OC', 'DN', 'PL', 'IN', 'PFIN', 'CN', 'PFCN'].includes(CompilationTypeData.get(this.compilation.type).code)) {
              filename = `${date}_${name ? name : 'UNKNOWN'}_${docnum}_${customerDoc}${poPos}${customerCode}${revised}${cancelled}${copyTxt}`;
            } else if (['CS'].includes(CompilationTypeData.get(this.compilation.type).code)) {
              const exwDate = this.datePipe.transform(this.compilation.exwJapanDate, 'yyMMdd');
              const method = this.compilation.meansOfTransport ? this.compilation.meansOfTransport.replace(/FREIGHT/,'') : '-';
              filename = `${date}_${name ? name : 'UNKNOWN'} ${exwDate} ${method}_${docnum}${revised}${cancelled}${copyTxt}`;
            } else{
              filename = `${date}_${name ? name : 'UNKNOWN'}_${docnum}${revised}${cancelled}${copyTxt}`;
            }
          // });
        } else {
          // eslint-disable-next-line max-len
          if (['OR', 'OC', 'DN', 'PL', 'IN', 'PFIN', 'CN', 'PFCN'].includes(CompilationTypeData.get(this.compilation.type).code)) {
            filename = `${date}_UNKNOWN_${docnum}_${customerDoc}${poPos}${customerCode}${revised}${cancelled}${copyTxt}`
          } else {
            filename = `${date}_UNKNOWN_${docnum}${revised}${cancelled}${copyTxt}`
          }
        }
        console.log('saveAs', filename.trim() + ext);
        if (res.size) saveAs(res, filename.trim() + ext);
        if (+this.compilation.type === CompilationTypeData.get('IN').id) {
          await this.api.setInvoiceDownloaded(this.compilation._id)
        }
        resolve(null);
      });
    });
  }

  getTitle(codeOnly = false) {
    const name = getDocumentNumber(this.compilation, null, false);
    if (codeOnly) return name;
    const invoicePayment = this.compilation.invoicePayment > 0
      ? ` (${InvoicePaymentData.get(this.compilation.invoicePayment).name})`: '';
    const cancelled = +this.compilation.documentStatus === DocumentStatusData.get('cancelled').id ? ' (cancelled)' : '';
    const revised = +this.compilation.documentStatus === DocumentStatusData.get('revised').id ? ' (revised)' : '';
    let type = CompilationTypeData.getHeading(this.compilation); // CompilationTypeData.get(this.compilation.type).name;
    if (+this.compilation.type === CompilationTypeData.get('SPC').id) type = 'Supplier purchase order';
    if (+this.compilation.type === CompilationTypeData.get('PFSPC').id) type = 'Proforma supplier purchase order';
    return [type + ' ' + name + invoicePayment + cancelled + revised, type, name + invoicePayment + cancelled + revised];
  }

  // getIssuer() {
  //   return this.compilation.issuerAddress && this.compilation.issuerAddress.replace(/\n.*/g, '');
  // }

  // getBusinessUnits() {
  //   const products = this.compilation?.lineItems?.map(m => m.finishedProduct?.product).filter(notNull => notNull);
  //   const businessUnits = products?.map(m => m.businessUnit?.name);
  //   const set = Array.from(new Set(businessUnits));
  //   // console.log('==>', products, businessUnits, set);
  //   return set.join(', ');
  // }

  getPercentText() {
    const arr = this.compilation.lineItems.map(li => li.invoicePercent);
    if (arr.every(val => val === arr[0])) {
      return `${this.compilation.invoicePercent}% ${InvoicePaymentData.get(this.compilation.invoicePayment).name} `;
    }
    return `${InvoicePaymentData.get(this.compilation.invoicePayment).name} `;
  }

  getCustomerReferenceName() {
    const b = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.customerReference));
    return (b && b.name) || '';
  }

  // getItemOrderPos(item) {
  //   const idx = this.orderLineItems?.findIndex(f => f.position?.internalPos === item.position?.orderPos);
   
  //   // console.log('calced idx', idx, item, this.orderLineItems);
  //   // console.log('cidx', (idx !== null && idx >= 0) ? idx + 1 : '')
  //   // console.log('cidx', (idx !== null && idx >= 0) ? idx + 1 : '')
  //   // console.log('cidx', (idx !== null && idx >= 0) ? idx + 1 : '')
  //   return (idx !== null && idx >= 0) ? idx + 1 : ''; 
  // }

  // getBoxBlockValues(field: string, item: LineItemModel) {
  //   return item.pfspo?.map(m => m.docLineItem && m.docLineItem[field].replace(/T\d\d\:\d\d\:\d\d.*/,''))?.filter(notNull => notNull).join('\n');
  // }

  // getBoxBlockValues(field: string, lineItemIdx: number) {
  //   return this.boxBlockLines && this.boxBlockLines[lineItemIdx]?.map(m => m[field]).join('\n') || 'N/A';
  //   // return item.pfspo?.map(m => m.docLineItem && m.docLineItem[field]?.replace(/T\d\d\:\d\d\:\d\d.*/,''))?.filter(notNull => notNull).join('\n') || 'n/a';
  // }

  // getPositionNumberFormat() {
  //   //console.log('recipient', this.compilation.recipient, this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient)));
  //   const business = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient));
  //   return business.positionNumberFormat || '%02d';
  // }


}
